const actionTypes = {
    CREATE_CART: 'CREATE_CART',
    ADD_UPDATE_CART: 'ADD_UPDATE_CART',
    FETCH_CART: 'FETCH_CART',
    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART',
    ADD_CART_ITEM: 'ADD_CART_ITEM',
    DROP_CART: 'DROP_CART',
};

export { actionTypes };
